import { primary, secondary, text } from '@/theme/colors/palettes';
import { HStack, Text, VStack } from '@chakra-ui/react';
import BarSegment from './BarSegment';
import { BAR_HEIGHT, formatSubdomainLabel, MIN_SEGMENT_PX, StackedRow } from './helpers';

interface Props {
  row: StackedRow;
  maxTotal: number;
  totalPosition: 'left' | 'right';
}

const ConcernRow = ({ row, maxTotal, totalPosition }: Props) => {
  const peerSupportLeft = row.peerSupportCount <= row.screenerCount;
  const widthPercent = (row.total / maxTotal) * 100;
  const segmentCount = (row.peerSupportCount > 0 ? 1 : 0) + (row.screenerCount > 0 ? 1 : 0);
  const minBarPx = Math.max(segmentCount, 1) * MIN_SEGMENT_PX;

  const labelKey = row.isOther ? 'Other Concerns' : formatSubdomainLabel(row.category);

  return (
    <VStack alignItems={'stretch'} gap={'8px'}>
      <HStack gap={'4px'} alignItems={'center'} justifyContent={'flex-start'}>
        {totalPosition === 'left' && (
          <Text variant={'urbanistBold'} color={text.darkBlue} fontWeight={700}>
            {row.total}
          </Text>
        )}
        <Text
          variant={'urbanistSemiBoldRegular'}
          color={text.darkBlue}
          noOfLines={1}
          title={labelKey}
          fontWeight={600}
          // flex={totalPosition === 'right' ? 1 : undefined}
        >
          {labelKey}
        </Text>
        {totalPosition === 'right' && (
          <Text variant={'urbanistBold'} color={text.mediumBlue} fontWeight={800}>
            {row.total}
          </Text>
        )}
      </HStack>

      <HStack
        width={`${widthPercent}%`}
        minWidth={`${minBarPx}px`}
        height={`${BAR_HEIGHT}px`}
        borderRadius={`8px`}
        overflow={'hidden'}
        gap={0}
      >
        {peerSupportLeft ? (
          <>
            <BarSegment color={secondary[500]} grow={row.peerSupportCount} value={row.peerSupportCount} />
            <BarSegment color={primary[500]} grow={row.screenerCount} value={row.screenerCount} />
          </>
        ) : (
          <>
            <BarSegment color={primary[500]} grow={row.screenerCount} value={row.screenerCount} />
            <BarSegment color={secondary[500]} grow={row.peerSupportCount} value={row.peerSupportCount} />
          </>
        )}
      </HStack>
    </VStack>
  );
};

export default ConcernRow;
